export const REQUEST_ADMIN_ACCOUNT = 'REQUEST_ADMIN_ACCOUNT'
export const REQUEST_ACCOUNT_LIST = 'REQUEST_ACCOUNT_LIST'